import { Toaster } from "sonner";

import { TOASTER_BEHIND_DIALOG_Z_INDEX, useIsDialogOpen } from "~/hooks/useOverlayState";

export const NotificationToaster = () => {
  const isDialogOpen = useIsDialogOpen();

  return (
    <Toaster
      id="notifications"
      className="notifications-toaster"
      position="top-right"
      swipeDirections={["right"]}
      visibleToasts={Infinity}
      gap={10}
      offset={{ top: 40, right: 18 }}
      mobileOffset={{ top: 60 }}
      closeButton={true}
      style={isDialogOpen ? { zIndex: TOASTER_BEHIND_DIALOG_Z_INDEX } : undefined}
    />
  );
};
